(function () {
  'use strict';

  var MARKER = 'AURAKIN_CONTACT_SCHEME_B_20260803';
  var WIDGET_ID = 'ak-dual-contact-widget';
  var STYLE_ID = 'ak-dual-contact-widget-style-20260803';
  var TELEGRAM_URL = 'https://t.me/AurakinBot?start=site_contact_widget';
  var WHATSAPP_URL = 'https://wa.me/19934551931?text=Hi%20AuraKin%2C%20I%20would%20like%20help%20choosing%20a%20jade%20jewelry%20piece.';
  var NATIVE_SELECTORS = '#carthike-chat-button-container,#chwhatsapp-btn,.whatsappbutton.buttonWithTextIcon,inbox-online-store-chat#ShopifyChat,#ShopifyChat';

  if (window.__akContactSchemeBLoaded && document.getElementById(WIDGET_ID)) return;
  window.__akContactSchemeBLoaded = true;

  function installStyle() {
    var style = document.getElementById(STYLE_ID) || document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '/* ' + MARKER + ' */',
      NATIVE_SELECTORS + '{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}',
      '#'+WIDGET_ID+'{position:fixed!important;right:24px!important;bottom:18px!important;z-index:90!important;display:grid!important;gap:10px!important;justify-items:end!important;pointer-events:none!important}',
      '#'+WIDGET_ID+' a{pointer-events:auto!important;display:grid!important;width:50px!important;height:50px!important;place-items:center!important;border:1px solid rgba(255,255,255,.28)!important;border-radius:999px!important;color:#fff!important;text-decoration:none!important;box-shadow:0 13px 30px rgba(0,0,0,.38),inset 0 1px 0 rgba(255,255,255,.22)!important;transition:transform .18s ease,border-color .18s ease,box-shadow .18s ease!important;-webkit-tap-highlight-color:transparent!important}',
      '#'+WIDGET_ID+' a:hover{transform:translateY(-2px)!important;border-color:rgba(255,255,255,.7)!important;box-shadow:0 16px 36px rgba(0,0,0,.44),0 0 0 3px rgba(255,255,255,.12)!important}',
      '#'+WIDGET_ID+' a:focus-visible{outline:2px solid #f4ddaa!important;outline-offset:3px!important}',
      '#'+WIDGET_ID+' svg{display:block!important;width:23px!important;height:23px!important;fill:currentColor!important}',
      '#'+WIDGET_ID+' .ak-tg{background:#229ED9!important}',
      '#'+WIDGET_ID+' .ak-wa{background:#25D366!important}',
      'body.ak-contact-preview-bar #'+WIDGET_ID+'{bottom:86px!important}',
      '@media(max-width:749px){#'+WIDGET_ID+'{right:14px!important;bottom:max(92px,calc(env(safe-area-inset-bottom,0px) + 80px))!important;gap:8px!important}body.ak-contact-preview-bar #'+WIDGET_ID+'{bottom:max(92px,calc(env(safe-area-inset-bottom,0px) + 80px))!important}#'+WIDGET_ID+' a{width:46px!important;height:46px!important}#'+WIDGET_ID+' svg{width:21px!important;height:21px!important}}',
      '@media(prefers-reduced-motion:reduce){#'+WIDGET_ID+' a{transition:none!important}}'
    ].join('');
    if (!style.parentNode) document.head.appendChild(style);
  }

  function hideNativeWidgets() {
    try {
      document.querySelectorAll(NATIVE_SELECTORS).forEach(function (element) {
        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('opacity', '0', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      });
    } catch (error) {}
  }

  function markPageContext() {
    var previewBar = document.getElementById('PBarNextFrameWrapper');
    var previewRect = previewBar ? previewBar.getBoundingClientRect() : null;
    var previewStyle = previewBar ? window.getComputedStyle(previewBar) : null;
    var hasVisiblePreviewBar = Boolean(previewBar && previewRect && previewRect.height > 0 &&
      previewStyle.display !== 'none' && previewStyle.visibility !== 'hidden');
    document.body.classList.toggle('ak-contact-preview-bar', hasVisiblePreviewBar);
  }

  var contextUpdatePending = false;
  function schedulePageContextUpdate() {
    if (contextUpdatePending) return;
    contextUpdatePending = true;
    window.requestAnimationFrame(function () {
      contextUpdatePending = false;
      markPageContext();
    });
  }

  function mount() {
    if (!document.body) return;
    installStyle();
    hideNativeWidgets();
    markPageContext();

    var existing = document.getElementById(WIDGET_ID);
    if (existing) existing.remove();

    var widget = document.createElement('aside');
    widget.id = WIDGET_ID;
    widget.setAttribute('data-ak-contact-scheme', 'B-20260803');
    widget.setAttribute('aria-label', 'Contact an AuraKin jade advisor');
    widget.innerHTML =
      '<a class="ak-tg" href="' + TELEGRAM_URL + '" target="_blank" rel="noopener noreferrer" aria-label="Contact AuraKin on Telegram" title="Telegram">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.8 4.1 18.4 20c-.25 1.12-.92 1.39-1.86.87l-5.15-3.8-2.49 2.39c-.27.27-.5.5-1.03.5l.37-5.25 9.56-8.64c.42-.37-.09-.58-.64-.21L5.34 13.3.25 11.7c-1.1-.34-1.12-1.1.23-1.63L20.37 2.4c.92-.34 1.73.22 1.43 1.7Z"/></svg>' +
      '</a>' +
      '<a class="ak-wa" href="' + WHATSAPP_URL + '" target="_blank" rel="noopener noreferrer" aria-label="Contact AuraKin on WhatsApp" title="WhatsApp">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 3.5A11.86 11.86 0 0 0 12.06 0C5.49 0 .15 5.34.15 11.91c0 2.1.55 4.16 1.6 5.97L0 24l6.28-1.65a11.9 11.9 0 0 0 5.77 1.47h.01c6.57 0 11.91-5.34 11.91-11.91 0-3.18-1.24-6.17-3.47-8.41ZM12.06 21.8h-.01a9.86 9.86 0 0 1-5.03-1.38l-.36-.21-3.72.98.99-3.63-.23-.37a9.86 9.86 0 0 1-1.51-5.28c0-5.45 4.43-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.9 9.88Zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.91-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.87 1.21 3.07c.15.2 2.09 3.19 5.06 4.47.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35Z"/></svg>' +
      '</a>';
    document.body.appendChild(widget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }

  window.addEventListener('load', function () {
    hideNativeWidgets();
    markPageContext();
  }, { once: true });

  window.addEventListener('resize', schedulePageContextUpdate, { passive: true });

  var observer = new MutationObserver(function () {
    hideNativeWidgets();
    markPageContext();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
